export default __webpack_public_path__ + "static/media/logo.fdd81be8.svg";